import React from 'react';
import '../UploadForm.css';
import FileIcon from '../../assets/icons/file_icon3.svg';

function DropArea({
  isDragging,
  onClick,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
  fileInputRef,
  onFilesChange,
  disabled = false,
}) {
  return (
    <div className={`drop-resume-container ${disabled ? 'disabled' : ''}`} aria-disabled={disabled}>
      <div
        className={`upload-area-container ${isDragging ? 'dragging' : ''} ${disabled ? 'disabled' : ''}`}
        onClick={disabled ? undefined : onClick}
        onDragEnter={disabled ? undefined : onDragEnter}
        onDragLeave={disabled ? undefined : onDragLeave}
        onDragOver={disabled ? undefined : onDragOver}
        onDrop={disabled ? undefined : onDrop}
        aria-disabled={disabled}
      >
        <div className="file-icon">
          <img src={FileIcon} alt="file icon" />
        </div>
        <div className="upload-area-container-text">
          <p style={{ cursor: 'pointer' }}>
            <label style={{ cursor: 'pointer' }}>
              {' '}
              Drop resume(s) or{' '}
              <span
                style={{
                  alignSelf: 'center',
                  marginBottom: '0',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  color: '#6e41c1',
                }}
              >
                upload here
              </span>
            </label>
          </p>
          <p style={{ color: '#666', fontSize: '0.8em' }}>
            Supported formats: PDF, DOCX, TXT (Max. 8)
          </p>
        </div>

        <input
          type="file"
          multiple
          onChange={disabled ? undefined : onFilesChange}
          accept=".pdf,.docx,.txt"
          id="resume-upload"
          ref={fileInputRef}
          style={{ display: 'none' }}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default DropArea;


